import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import InputDisplayTemplate from '../../components/InputDisplayTemplate'

const SeniorCitizenInformation = ({ seniorCitizenInfo }) => {
  return (
    <>
      <div className="row d-flex  mb-1 p-3" style={{height:'500px', overflowY:'scroll', }}>
        <h3 className="cms-text-primary font-weight-bold py-2">Type of Pension</h3>
        <div className="col-12 mb-3 p-1 form-wrapper-alternate-bg">
          <InputDisplayTemplate title="Type of Pension" dataItem={_.get(seniorCitizenInfo, 'attributes.pension_name') || '- -'} />
        </div>
        <h3 className="cms-text-primary font-weight-bold py-2">Mortuary Aid</h3>
        <div className="col-12 mb-3 p-1 form-wrapper-alternate-bg">
          <InputDisplayTemplate title="Mortuary Aid" dataItem={_.get(seniorCitizenInfo, 'attributes.has_mortuary_aid') ? 'Yes' : 'No' || '- -'} />
        </div>
        <h3 className="cms-text-primary font-weight-bold py-2">Personal Information</h3>
        <div className="col-12 mb-3 p-1 form-wrapper-alternate-bg">
          <InputDisplayTemplate title="Last Name" dataItem={_.get(seniorCitizenInfo, 'attributes.last_name') || '- -'} />
          <InputDisplayTemplate title="First Name" dataItem={_.get(seniorCitizenInfo, 'attributes.first_name') || '- -'} />
          <InputDisplayTemplate title="Middle Name" dataItem={(_.get(seniorCitizenInfo, 'attributes.middle_name'))  || '- -'} />
          <InputDisplayTemplate title="Suffix" dataItem={_.get(seniorCitizenInfo, 'attributes.extension_name') || '- -'} />
          <InputDisplayTemplate title="Gender" dataItem={_.get(seniorCitizenInfo, 'attributes.gender') || '- -'} />
          <InputDisplayTemplate title="Date of Birth" dataItem={_.get(seniorCitizenInfo, 'attributes.birth_date') || '- -'} />
          <InputDisplayTemplate title="Age" dataItem={(_.get(seniorCitizenInfo, 'attributes.age'))  || '- -'} />
          <InputDisplayTemplate title="Centenarian" dataItem={_.get(seniorCitizenInfo, 'attributes.is_centenarian') ? 'Yes' : 'No' || '- -'} />
        </div>
        <h3 className="col-12 cms-text-primary font-weight-bold py-2">Contact Information</h3>
        <div className="col-12 mb-3 p-1 form-wrapper-alternate-bg">
          <InputDisplayTemplate title="Email Address" dataItem={(_.get(seniorCitizenInfo, 'attributes.email'))  || '- -'} />
          <InputDisplayTemplate title="Mobile Number" dataItem={(_.get(seniorCitizenInfo, 'attributes.mobile_number')) || '- -'} />
          <InputDisplayTemplate title="Telephone Number" dataItem={_.get(seniorCitizenInfo, 'attributes.telephone_number') || '- -'} />
        </div>
        <h3 className="col-12 cms-text-primary font-weight-bold py-2">Address</h3>
        <div className="col-12 mb-3 p-1 form-wrapper-alternate-bg">
          <InputDisplayTemplate title="Region" dataItem={_.get(seniorCitizenInfo, 'attributes.region_name') || '- -'} />
          <InputDisplayTemplate title="Province" dataItem={_.get(seniorCitizenInfo, 'attributes.province_name') || '- -'} />
          <InputDisplayTemplate title="Municipality" dataItem={_.get(seniorCitizenInfo, 'attributes.municipality_name') || '- -'} />
          <InputDisplayTemplate title="Barangay" dataItem={_.get(seniorCitizenInfo, 'attributes.barangay_name') || '- -'} />
          <InputDisplayTemplate title="Zone" dataItem={_.get(seniorCitizenInfo, 'attributes.zone') || '- -'} />
          <InputDisplayTemplate title="Unit No. / House No. / Street Name" dataItem={_.get(seniorCitizenInfo, 'attributes.address') || '- -'} />
        </div>
        
        <h3 className="col-12 cms-text-primary font-weight-bold py-2">Place of Birth</h3>
        <div className="col-12 mb-3 p-1 form-wrapper-alternate-bg">
          <InputDisplayTemplate title="Region" dataItem={_.get(seniorCitizenInfo, 'attributes.place_of_birth_region_name') || '- -'} />
          <InputDisplayTemplate title="Province" dataItem={_.get(seniorCitizenInfo, 'attributes.place_of_birth_province_name') || '- -'} />
          <InputDisplayTemplate title="Municipality" dataItem={_.get(seniorCitizenInfo, 'attributes.place_of_birth_municipality_name') || '- -'} />
          <InputDisplayTemplate title="Date of Birth" dataItem={_.get(seniorCitizenInfo, 'attributes.birth_date') || '- -'} />
        </div>
        <h2 className="col-12 cms-text-primary font-weight-bold pb-2 pt-3">Family Information</h2>

        <h3 className="col-12 cms-text-primary font-weight-bold py-2">Mothers Maiden Name</h3>
        <div className="col-12 mb-3 p-1 form-wrapper-alternate-bg">
          <InputDisplayTemplate title="Last Name" dataItem={_.get(seniorCitizenInfo, 'attributes.mother_maiden_last_name') || '- -'} />
          <InputDisplayTemplate title="First Name" dataItem={_.get(seniorCitizenInfo, 'attributes.mother_maiden_first_name') || '- -'} />
          <InputDisplayTemplate title="Middle Name" dataItem={(_.get(seniorCitizenInfo, 'attributes.mother_maiden_middle_name')) || '- -'} />
        </div>

        <h3 className="col-12 cms-text-primary font-weight-bold py-2">Fathers Name</h3>
        <div className="col-12 mb-3 p-1 form-wrapper-alternate-bg">
          <InputDisplayTemplate title="Last Name" dataItem={_.get(seniorCitizenInfo, 'attributes.father_last_name') || '- -'} />
          <InputDisplayTemplate title="First Name" dataItem={_.get(seniorCitizenInfo, 'attributes.father_first_name') || '- -'} />
          <InputDisplayTemplate title="Middle Name" dataItem={(_.get(seniorCitizenInfo, 'attributes.father_middle_name'))  || '- -'} />
        </div>

        <h3 className="col-12 cms-text-primary font-weight-bold py-2">Spouse Name</h3>
        <div className="col-12 mb-3 p-1 form-wrapper-alternate-bg">
          <InputDisplayTemplate title="Last Name" dataItem={_.get(seniorCitizenInfo, 'attributes.spouse_last_name') || '- -'} />
          <InputDisplayTemplate title="First Name" dataItem={_.get(seniorCitizenInfo, 'attributes.spouse_first_name') || '- -'} />
          <InputDisplayTemplate title="Middle Name" dataItem={(_.get(seniorCitizenInfo, 'attributes.spouse_middle_name'))  || '- -'} />
        </div>

        <h3 className="col-12 cms-text-primary font-weight-bold py-2">Identity Information</h3>
        <div className="col-12 mb-3 p-1 form-wrapper-alternate-bg">
          <InputDisplayTemplate title="Height" dataItem={_.get(seniorCitizenInfo, 'attributes.height') || '- -'} />
          <InputDisplayTemplate title="Weight" dataItem={_.get(seniorCitizenInfo, 'attributes.weight') || '- -'} />
          <InputDisplayTemplate title="Complexion" dataItem={(_.get(seniorCitizenInfo, 'attributes.complexion'))  || '- -'} />
          <InputDisplayTemplate title="Country of Citizenship" dataItem={(_.get(seniorCitizenInfo, 'attributes.citizenship_code'))  || '- -'} />
        </div>

        <h3 className="col-12 cms-text-primary font-weight-bold py-2">Educational Information</h3>
        <div className="col-12 mb-3 p-1 form-wrapper-alternate-bg">
          <InputDisplayTemplate title="Highest Educational Attainment" dataItem={_.get(seniorCitizenInfo, 'attributes.educational_attainment') || '- -'} />
          <InputDisplayTemplate title="Institution" dataItem={_.get(seniorCitizenInfo, 'attributes.institution_name') || '- -'} />
        </div>

        <h3 className="col-12 cms-text-primary font-weight-bold py-2">Valid ID</h3>
        <div className="col-12 mb-3 p-1 form-wrapper-alternate-bg">
          <InputDisplayTemplate title="Type of Valid ID" dataItem={_.get(seniorCitizenInfo, 'attributes.id_type') || '- -'} />
          <InputDisplayTemplate title="Valid ID" dataItem={_.get(seniorCitizenInfo, 'attributes.id_url') || '- -'} isImage />
        </div>
      </div>
    </>
  );
};

SeniorCitizenInformation.propTypes = {
  seniorCitizenInfo: PropTypes.instanceOf(Object).isRequired,
};

export default SeniorCitizenInformation;
